import { Component, Input } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";

@Component({
    selector: "cerrix-loader",
    templateUrl: "./cerrix-loader.component.html",
    styleUrls: ["./cerrix-loader.component.scss"],
    viewProviders: [
        provideTranslationScope(scope)
    ],
    imports: [TranslatePipe]
})
export class CerrixLoaderComponent {
    @Input() cerrixTab: TabModel;
    @Input() showLoader = false;
    @Input() customMessage: string = "";
}
